import { h } from 'preact'
import { i18n } from 'i18n/i18n'

import { ExchangeDirection } from 'models/exchange-transfer-calculate'

import { SelectSingleOption } from 'common-modules/selects/calculator-select-option'
import { useSelectVisibility } from 'hooks/useSelectVisibility'

interface CalculatorDirectionSelectProps {
  options: ExchangeDirection[]
  direction: ExchangeDirection
  setDirection: (direction: ExchangeDirection) => void
  isDarkMode?: boolean
}

export const CalculatorDirectionSelect = ({
  options,
  direction,
  setDirection,
  isDarkMode,
}: CalculatorDirectionSelectProps) => {
  const {
    isSelectVisible,
    toggleSelectVisibility,
    triggerRef,
    containerRef,
    listRef,
    handleTriggerKeyDown,
    handleListKeyDown,
  } = useSelectVisibility()

  const translateOption = (direction: ExchangeDirection): string =>
    direction === 'forward' ? String(i18n('widgetCalculator.buySelect')) : String(i18n('widgetCalculator.sellSelect'))

  return (
    <div
      ref={containerRef}
      className="preact-select"
      data-direction-holder
    >
      <div
        ref={triggerRef}
        className="preact-select__trigger"
        aria-expanded={isSelectVisible}
        role="button"
        tabIndex={0}
        onClick={toggleSelectVisibility}
        onKeyDown={handleTriggerKeyDown}
        data-value={translateOption(direction)}
        data-calculator-direction
      >
        <p>{translateOption(direction)}</p>
        <span className={`preact-select__chevron ${isDarkMode ? 'is-dark-mode' : ''}`} />
      </div>

      {isSelectVisible && (
        <div
          ref={listRef}
          className="preact-select__options-list"
          role="listbox"
          onKeyDown={handleListKeyDown}
          onClick={toggleSelectVisibility}
        >
          {options.map((option) => (
            <SelectSingleOption
              key={option}
              option={option}
              optionName={translateOption(option)}
              handleSetClickedOption={setDirection}
              isWithFlags={false}
            />
          ))}
        </div>
      )}
    </div>
  )
}
